var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightDarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1188_1118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1188_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 19.3001L19.725 12.7001C19.825 12.6001 19.896 12.4917 19.938 12.3751C19.9793 12.2584 20 12.1334 20 12.0001C20 11.8667 19.9793 11.7417 19.938 11.6251C19.896 11.5084 19.825 11.4001 19.725 11.3001L13.125 4.70008C12.9417 4.51675 12.7127 4.42075 12.438 4.41208C12.1627 4.40408 11.925 4.50008 11.725 4.70008C11.525 4.88342 11.4207 5.11242 11.412 5.38708C11.404 5.66242 11.5 5.90008 11.7 6.10008L16.6 11.0001H5.425C5.14167 11.0001 4.904 11.0957 4.712 11.2871C4.52067 11.4791 4.425 11.7167 4.425 12.0001C4.425 12.2834 4.52067 12.5207 4.712 12.7121C4.904 12.9041 5.14167 13.0001 5.425 13.0001H16.6L11.7 17.9001C11.5167 18.0834 11.4207 18.3167 11.412 18.6001C11.404 18.8834 11.5 19.1167 11.7 19.3001C11.8833 19.5001 12.1167 19.6001 12.4 19.6001C12.6833 19.6001 12.925 19.5001 13.125 19.3001Z",
    fill: "#1D8158"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDarkGreen);
export default __webpack_public_path__ + "static/media/arrow-right-dark-green.12094cb7a1dda020f40960568fba86d1.svg";
export { ForwardRef as ReactComponent };